export default __webpack_public_path__ + "static/media/pop.ed9d2831.png";